import styled from "@emotion/styled"
import background from "../../images/coming-soon-overlay.jpg"

export const MainContainer = styled.div`
  background: #000;
  padding: 120px 0;
  padding-top: 80px;
  margin-bottom: 10px;
`

export const InnerContainer = styled.div`
  width: 80%;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(308px, 1fr));
  grid-gap: 44px;
  @media (max-width: 560px) {
    width: 87%;
  }
  @media (max-width: 340px) {
    width: 95%;
  }
`

export const RightBlock = styled.div`
  width: 64%;
`

export const SubHeading = styled.div`
  font-size: 15px;
  font-family: Poppins, sans-serif;
  font-weight: 500;
  color: #ffffff;
`

export const Heading = styled.div`
  font-size: 18px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  color: #fff;
  margin-bottom: 20px;
`

export const LeftBlock = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  background-image: linear-gradient(90deg, #4f3ec8 0%, #8957f6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 30px;
`

export const Section = styled.div`
  display: flex;
  align-items: flex-start;
  background: linear-gradient(
    45deg,
    #405de6,
    #5851db,
    #833ab4,
    #c13584,
    #e1306c,
    #fd1d1d
  );
  padding: 10px;
  border-radius: 8px;
  @media (max-width: 325px) {
    padding: 10px 2px;
  }
`
